export default "__VITE_ASSET__BP9eWbb5__"